import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import MoreHoriz from '@mui/icons-material/MoreHoriz';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import styles from '../styles/uikitLayoutsBreadcrumbsBar.module.scss';

const BreadcrumbsBar = ({
  children = null,
  className = '',
  hasMenu = false,
  isKebabMenuDisabled = false,
  menuItems = [],
  testId = '',
}) => (
  <div className={classnames(styles.element, className)} data-testid={testId}>
    {children}
    {hasMenu && (
      <Menu
        component={
          <Button
            ariaLabel={i18n.t('options', 'Options')}
            icon={<MoreHoriz sx={{ height: 18, width: 18 }} />}
            iconSize={18}
            isDisabled={isKebabMenuDisabled}
            size="xsmall"
            variant="ghost"
          />
        }
        variant="bounded"
      >
        {menuItems}
      </Menu>
    )}
  </div>
);

BreadcrumbsBar.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  hasMenu: PropTypes.bool,
  isKebabMenuDisabled: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.element),
  testId: PropTypes.string,
};

export default BreadcrumbsBar;
